module.exports = __webpack_public_path__ + "69e00c7b5b3678f276caeeaca856cf0c.svg";